import isEmpty from "lodash/isEmpty";
import cloneDeep from "lodash/cloneDeep";
import { MessageTypeConstants } from "../../services/bot/Message";
import { handleMessageTypeMenu } from "../actionsHelpers/tabStackActionsHelpers/message-type-menu";
import { handleMessageTypeMap } from "../actionsHelpers/tabStackActionsHelpers/message-type-map";
import { handleMessageTypeTable } from "../actionsHelpers/tabStackActionsHelpers/message-type-table";
import { handleMessageTypeForm2 } from "../actionsHelpers/tabStackActionsHelpers/message-type-form2";
import { handleMessageTypeContainer } from "../actionsHelpers/tabStackActionsHelpers/message-type-container";
import { handleMessageTypeCalendar } from "../actionsHelpers/tabStackActionsHelpers/message-type-calender";
import { handleMessageTypeDashboard } from "../actionsHelpers/tabStackActionsHelpers/message-type-dashboard";
import { handleMessageTypeHtml } from "../actionsHelpers/tabStackActionsHelpers/message-type-html";
import { handleUnreadCountsFromBotMessage } from "../actionsHelpers/tabStackActionsHelpers/message-type-bot-chat";

import {
    BG_CALENDAR_TOOLBAR, REMOVE_PULL_DOWN_MENU, REMOVE_TAB, RENDER_MESSAGE_TYPE_FORM2,
    RESET_FORM2_FIELDS, RESET_TAB_STACK, SET_CURRENT_RENDERED_TAB, TAB_CHANGE, TAB_STATE_CHANGE
} from "../constants";
import { renderNonconversationalFilter } from "./filters";
import { setInitializeChatInWindow, setShowChatInWindow } from "./chats";
import { isObject } from "lodash";
import { IM_BOT } from "../../utils/constants";
import { handleMessageTypeCatalog } from "../actionsHelpers/tabStackActionsHelpers/message-type-catalog";


export const handleTabStack = (conversationId, message) => (dispatch) => {
    // console.log("%c TAB STACK ACTION HANDLING MAIN ", "color: orange;", "messageType : ", message.messageType)
    if (!message.messageType || message.messageType === undefined) return;

    switch (message.messageType) {
        case MessageTypeConstants.MESSAGE_TYPE_MENU:
            dispatch(handleMessageTypeMenu(conversationId, message));
            break;

        case MessageTypeConstants.MESSAGE_TYPE_MAP:
            dispatch(handleMessageTypeMap(conversationId, message));
            break;

        case MessageTypeConstants.MESSAGE_TYPE_TABLE:
            if (["changeFilter", "validationFilter", "resultsFilter", "updateFilter"].includes(message.options.action)) {
                dispatch(renderNonconversationalFilter(message));
            }
            else {
                dispatch(handleMessageTypeTable(conversationId, message, false, false));
            }
            break;

        case MessageTypeConstants.MESSAGE_TYPE_DASHBOARD:
        case 5000:
            dispatch(handleMessageTypeDashboard(conversationId, message));
            break;

        case MessageTypeConstants.MESSAGE_TYPE_FORM2:
            if (["changeFilter", "validationFilter", "resultsFilter", "updateFilter"].includes(message.options.action)) {
                dispatch(renderNonconversationalFilter(message));
            }
            else {
                dispatch(handleMessageTypeForm2(conversationId, message));
            }
            break;

        case MessageTypeConstants.MESSAGE_TYPE_CONTAINER:
            dispatch(handleMessageTypeContainer(conversationId, message));
            break;

        case MessageTypeConstants.MESSAGE_TYPE_CALENDAR:
            dispatch(handleMessageTypeCalendar(conversationId, message));
            break;

        case MessageTypeConstants.MESSAGE_TYPE_HTML:
            dispatch(handleMessageTypeHtml(conversationId, message));
            break;

        case MessageTypeConstants.MESSAGE_TYPE_CATALOG:
            dispatch(handleMessageTypeCatalog(conversationId, message));
            break;

        case MessageTypeConstants.MESSAGE_TYPE_CHAT:
            if (
                message?.message &&
                isObject(message?.message) &&
                Object.keys(message.message).length > 0
            ) {
                dispatch(setShowChatInWindow(true, message));
            }
            else {
                dispatch(setInitializeChatInWindow(message))
            }
            break;
    }

    // handle 1-1 chat messages received from socket to im-bot
    if (message?.bot) {
        switch (message.bot) {
            case IM_BOT:
                if (["10", "30", "40", "60", "290", "310", "320", "330", "340",].includes(message?.contentType)) {
                    dispatch(handleUnreadCountsFromBotMessage(conversationId, message))
                }
        }
    }
};

export const setCurrentRenderedTab = ( tab) => (dispatch) => {
  dispatch({
    type: SET_CURRENT_RENDERED_TAB,
    data: tab

  });
};

export const processAndRemoveTab = (conversationId, message) => (dispatch, getState) => {
    dispatch(setTabState(false))
    const stack = getState().tabStack?.[conversationId];
    const deletedTabId = message?.options?.tabId;
    const isModalTab = message?.options?.modal || null
    const isFormTypeAndModal = (message?.options?.modal && message.messageType === MessageTypeConstants.MESSAGE_TYPE_FORM2)
    if (!stack || !Array.isArray(stack.components) || !deletedTabId) return;

    const updatedComponents = removeDeletedComponent(stack.components, deletedTabId, isFormTypeAndModal);
    const newSelectedTab = getNewSelectedTab(stack.components, stack.selectedTab, deletedTabId);

    dispatch({
        type: REMOVE_TAB,
        data: {
            [conversationId]: {
                ...stack,
                components: updatedComponents,
                ...(isFormTypeAndModal ? {} : { selectedTab: newSelectedTab }),
            },
        },
    });
};

// Remove the component associated with the deleted tab
const removeDeletedComponent = (components, deletedTabId, isModalTab) => {
    if (isModalTab) {
        let updatedComponents = [];
        for (const component of components) {
            if (component.options.modal && component.options.tabId === deletedTabId && (component.options.style !== "Breadcrumb")) {
                break; // exit early
            }
            updatedComponents.push(component);
        }

        return updatedComponents
    }
    return components.filter((item) => item?.options?.tabId !== deletedTabId);
};

export const setRemovePullDownMenu = (conversationId) => (dispatch, getState) => {
    const stack = getState().tabStack?.[conversationId];

    if (!stack || !Array.isArray(stack.components)) return;

    dispatch({
        type: REMOVE_PULL_DOWN_MENU,
        data: {
            [conversationId]: {
                ...stack,
                pullDownMenuComponent: null,
            },
        },
    });
};


const getNewSelectedTab = (components, currentSelectedTab, deletedTabId) => {
    if (deletedTabId !== currentSelectedTab) {
        // Case 1: An unselected tab is deleted, keep the current selected tab
        return currentSelectedTab;
    }

    const deletedTabIndex = components.findIndex(
        (item) => item?.options?.tabId === deletedTabId
    );

    // Case 2: Current selected tab is deleted and there is a previous tab
    if (deletedTabIndex > 0) {
        const previousTab = components[deletedTabIndex - 1];
        if (previousTab?.options?.tabId) {
            return previousTab.options.tabId;
        }
    };

    // Case 3: Current selected tab is deleted and there is no previous tab but there is a next tab
    if (deletedTabIndex < components.length) {
        const nextTab = components[deletedTabIndex + 1];
        if (nextTab?.options?.tabId) {
            return nextTab.options.tabId;
        }
    };

    // Case 4: Current selected tab is deleted and there is neither a previous nor a next tab
    return "";
};


export const handleTabChangeAction = (conversationId, selectedTab) => (dispatch, getState) => {
    const state = getState().tabStack;
    const currentStack = state?.[conversationId];

    if (!currentStack) return;

    const updatedData = {
        ...currentStack,
        selectedTab,
        components: currentStack.components || [],
    };

    dispatch({
        type: TAB_CHANGE,
        data: {
            [conversationId]: updatedData,
        },
    });
};

export const setTabState = (data) => (dispatch) => {
    dispatch({
        type: TAB_STATE_CHANGE,
        data: {
            tabState: data
        }
    });
}

export const handleBreadcrumbChangeAction = (conversationId, parentTabId, selectedBreadcrumbTabId) => (dispatch, getState) => {
    const state = getState().tabStack;
    const currentStack = state?.[conversationId];

    if (!currentStack) return;

    const updatedComponents = currentStack.components.map(component => {
        if (component.options?.tabId === parentTabId) {
            return {
                ...component,
                selectedBreadcrumbTabId
            };
        }
        return component;
    });

    const updatedData = {
        ...currentStack,
        components: updatedComponents
    };

    dispatch({
        type: TAB_CHANGE,
        data: {
            [conversationId]: updatedData,
        },
    });
};


export const handleForm2PromptOnCloseAction = (tabStack, promptOnClose) => {

    const updatedComponents = tabStack.components.map((component) => {
        return {
            ...component,
            options: {
                ...component.options,
                promptOnClose,
            },
        };
    });

    return {
        ...tabStack,
        components: updatedComponents,
    };
}


export const handlePromptOnClose = (conversationId, promptOnClose = false) => (dispatch, getState) => {
    const currentStack = getState().tabStack?.[conversationId];

    if (!currentStack) return;

    const updatedData = handleForm2PromptOnCloseAction(currentStack, promptOnClose);

    dispatch({
        type: RENDER_MESSAGE_TYPE_FORM2,
        data: {
            [conversationId]: updatedData,
        },
    });
}

export const resetForm2Fields = (conversationId, message) => (dispatch, getState) => {
    const state = getState().tabStack;
    if (isEmpty(state)) return;

    const clonedData = cloneDeep(state[conversationId]);
    if (!clonedData?.components?.length) return;

    const tabIdToMatch = message?.options?.tabId;
    const message_sectionId = message?.options?.sectionId;

    clonedData.components.forEach((component) => {
        if (component?.options?.tabId !== tabIdToMatch) return;

        const collectionData = component?.message?.collectionData;

        // Update specific collection section if applicable
        if (
            message_sectionId &&
            collectionData &&
            typeof collectionData === 'object' &&
            collectionData[message_sectionId]
        ) {
            component.message = {
                ...component.message,
                collectionData: {
                    ...collectionData,
                    [message_sectionId]: {
                        ...collectionData[message_sectionId],
                        rows: newRows,
                    }
                },
                options: {
                    ...component.message.options,
                    pages: message.options.pages
                }
            };

            return;
        }

        // Handle empty or irrelevant fields (won't run in your current case)
        if (Array.isArray(component.message?.fields)) {
            component.message.fields.forEach((field) => {
                if (!field.readOnly) {
                    field.value = "";
                    if (!isEmpty(field.results)) {
                        field.results = [];
                    }
                }
            });
        }
    });

    dispatch({
        type: RESET_FORM2_FIELDS,
        data: {
            [conversationId]: clonedData,
        },
    });
};


export const handleCalendarToolBarChange = (payload) => (dispatch) => {
    dispatch({
        type: BG_CALENDAR_TOOLBAR,
        data: {
            bgClndrToolBarState: payload,
        },
    });
};


export const resetTabStack = () => (dispatch) => {
    dispatch({
        type: RESET_TAB_STACK,
    });
};

export const updateFilterFlags = (conversationId, message) => (dispatch, getState) => {
    const stack = getState().tabStack?.[conversationId];
    if (stack && !isEmpty(stack) && !isEmpty(stack.components)) {
        stack.components.forEach((item) => {
            if (
                item?.options?.tabId &&
                message?.options?.tabId &&
                item?.options?.tabId === message?.options?.tabId
            ) {
                let newMessage = cloneDeep(item);
                newMessage.options = message.options;
                switch (item.messageType) {
                    case MessageTypeConstants.MESSAGE_TYPE_CALENDAR:
                        if (["changeFilter", "validationFilter", "resultsFilter", "updateFilter"].includes(message.options.action)) {
                            dispatch(renderNonconversationalFilter(message));
                        } else {
                            dispatch(handleMessageTypeCalendar(conversationId, message));
                        }
                        break;
                    case MessageTypeConstants.MESSAGE_TYPE_MAP:
                        dispatch(handleMessageTypeTable(conversationId, newMessage));
                        break;
                    case MessageTypeConstants.MESSAGE_TYPE_TABLE:
                        dispatch(handleMessageTypeTable(conversationId, newMessage));
                        break;
                }
            }
            if (message?.options?.parentTabId === item?.options?.tabId) {
                item.message.forEach((itm) => {
                    if (itm?.message?.options?.tabId === message?.options?.tabId) {
                        itm.message.options.view = message.options.view;
                        itm.message.options.style = message.options.style;
                        itm.message.options.openDrawer = message.options.openDrawer;
                        itm.message.options.showFilterSearchInput =
                            message.options.showFilterSearchInput;
                        itm.message.options.isNewFilter = message.options.isNewFilter;
                        itm.message.options.parentTabId = item?.options?.tabId;
                        if (itm.message.options.openDrawer) {
                            dispatch(renderNonconversationalFilter(itm.message));
                        }
                    }
                });

                if (item?.options?.tabId === message?.options?.tabId) {
                    item.options.view = message.options.view;
                    item.options.style = message.options.style;
                    item.options.openDrawer = message.options.openDrawer;
                    item.options.showFilterSearchInput = message.options.showFilterSearchInput;
                    item.options.isNewFilter = message.options.isNewFilter;
                    item.options.parentTabId = item?.options?.tabId;
                    if (item.options.openDrawer) {
                        dispatch(renderNonconversationalFilter(item));
                    }
                }

                let newMessageContainer = cloneDeep(item);
                newMessageContainer.options = message.options;
                dispatch(handleMessageTypeContainer(conversationId, newMessageContainer));
            }
        });
    }
};